import { render, staticRenderFns } from "./DetailCustomer.vue?vue&type=template&id=08939548&"
import script from "./DetailCustomer.vue?vue&type=script&lang=js&"
export * from "./DetailCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DetailCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports